var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 0.958496L3.625 4.2085L0.375 4.2085L0.375 0.958496L3.625 0.958496Z",
    fill: "black",
    fillOpacity: 0.48
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 6.37516L3.625 9.62516L0.375 9.62516L0.375 6.37516L3.625 6.37516Z",
    fill: "black",
    fillOpacity: 0.48
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 15.0418L3.625 11.7918L0.375 11.7918L0.374999 15.0418L3.625 15.0418Z",
    fill: "black",
    fillOpacity: 0.48
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDots);
export default __webpack_public_path__ + "static/media/menuDots.5c48c9dfeffdda68089dd7ae3e3bc5ba.svg";
export { ForwardRef as ReactComponent };